export const SERVER_URL = process.env.REACT_APP_REACT_APP_SERVER_URL ?? 'http://127.0.0.1:8000/';
//export const SERVER_URL = 'https://api.tlsm.greenlabs.com.ar/';
export const PRODUCTION = false;